import useCurrentUser from "./useCurrentUser";

/**
 * Returns the current user's permission array or an empty fallback.
 *
 * Postconditions: Existing arrays are returned by reference; each missing-permissions evaluation
 * creates an empty array. No permission loading or mutation is initiated here.
 */
const useCurrentUserPermissions = () => {
    const userSummary = useCurrentUser();
    return userSummary?.permissions || [];
};

export default useCurrentUserPermissions;
